import LoadingButton from '@mui/lab/LoadingButton';
import {connect, isConnected} from "../../libs/aptos_wallet";
import {useDispatch} from "react-redux";
import {set} from "../../store/wallet";
import {useEffect, useState} from "react";
import {short_address} from "../../utils/common";

export default function LoginWallet() {
    const dispatch = useDispatch()
    const [buttonText, setButtonText] = useState("Connect Wallet")

    async function checkConnected() {
        const result = await isConnected()
        if (result){
           await  handleLogin()
        }
    }

    useEffect(() => {
        checkConnected()
    })


    const handleLogin = async () => {
        const result = await connect()
        setButtonText(short_address(result.address))
        dispatch(set(result.address))
    }

    return <LoadingButton onClick={async () => {
        await handleLogin()
    }} variant="outlined">
        {buttonText}
    </LoadingButton>
}